;(function ($, window, document) {
  function onDOMContentLoaded() {
    if ($('#cascade-menu').cascadeMenu) {
      $('#cascade-menu').cascadeMenu();
    }
  }
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
})(jQuery, window, document);
